import styled from '../../../../theme/styled-with-theme';
import { Text } from '../../../Text';
import { Flexbox } from 'src/components/Flexbox';
import { pxToRem } from '../../../../styles/utils';
import { Box } from '../../../Box';
import { mediaQueries } from '../../../../styles/media-queries';
import GlImage from '../../../Image';
import { ImageType } from './types';

interface CommonProps {
  listMode: boolean;
}

interface ArticleSnippetWrapperProps extends CommonProps {
  image: ImageType;
  category: string | undefined;
  showImage: boolean;
}

interface RowWrapperProps extends CommonProps {
  listMode: boolean;
}

interface ImageWrapperProps {
  large: boolean;
}

export const ArticleSnippetWrapper = styled(
  Flexbox
)<ArticleSnippetWrapperProps>`
  border-radius: ${pxToRem(16)};
  padding: ${pxToRem(16)};
  transition: background-color 0.2s ease;
  background-color: white;
  flex-direction: column;
  overflow: hidden;
  height: auto;

  ${mediaQueries.desktop} {
    ${({ showImage, listMode }) =>
      showImage && !listMode && `padding-bottom: ${pxToRem(16)};`}
  }
`;

export const HeaderText = styled(Text)<CommonProps>`
  font-size: ${pxToRem(22)};
  line-height: ${pxToRem(24)};
  margin-right: ${pxToRem(10)};
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;

  ${mediaQueries.desktop} {
    font-size: ${({ listMode }) => (listMode ? pxToRem(24) : pxToRem(20))};
    line-height: ${({ listMode }) => (listMode ? pxToRem(32) : pxToRem(24))};
  }
`;

export const SnippetSummaryText = styled(Text)`
  font-size: ${pxToRem(14)};
  line-height: ${pxToRem(18)};
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const RowWrapper = styled(Flexbox)<RowWrapperProps>`
  width: 100%;
  height: 100%;
  align-items: center !important;
  justify-content: space-between;
`;

export const BoxWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const ImageWrapper = styled('div')<ImageWrapperProps>`
  display: block;
  width: 100%;
  height: auto;
  position: relative !important;

  > span {
    position: unset !important;
  }
`;

export const StyledImage = styled(GlImage, {
  shouldForwardProp: (prop) => prop !== 'rounded'
})<{ rounded?: boolean }>`
  max-width: 100%;
  display: block;
  margin: 0 auto;
  width: 100%;
  object-fit: cover;
  border-radius: ${({ rounded }) => (rounded ? '12px' : 0)};
`;
